import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';

import LoginScreen from './screens/LoginScreen';
import ChooseArtistScreen from './screens/ChooseArtistScreen';
import ChooseProjectScreen from './screens/ChooseProjectScreen';
import DragDropScreen from './screens/DragDropScreen';

//Navigation import
import {NavigationContainer} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';


const App = () => {
  //const
  const Stack = createStackNavigator();

  return (
    <NavigationContainer>
      <Stack.Navigator
       screenOptions={{
         cardStyle: {
            backgroundColor: 'black',
          },
         headerShown: false
       }}
      >
        <Stack.Screen name="LoginScreen" component={LoginScreen} options={{title:"Demodeck Portal - Login"}}/>
        <Stack.Screen name="ChooseArtistScreen" component={ChooseArtistScreen} options={{title:"Demodeck Portal - Choose Artist"}}/>
        <Stack.Screen name="ChooseProjectScreen" component={ChooseProjectScreen} options={{title:"Demodeck Portal - Choose Project"}}/>
        <Stack.Screen name="DragDropScreen" component={DragDropScreen} options={{title:"Demodeck Portal - Upload Files"}}/>
      </Stack.Navigator>
    </NavigationContainer>
  );
};

export default App;
